/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { AddPermissionsUserGroupRequestToJSON, AddUsersUserGroupRequestToJSON, CreateUserGroupRequestToJSON, EntityPermissionsRepresentationFromJSON, PermissionRepresentationFromJSON, RemovePermissionsUserGroupRequestToJSON, RemoveUsersUserGroupRequestToJSON, SearchEntityPermissionsRequestToJSON, UpdateUserGroupRequestToJSON, UserGroupRepresentationFromJSON, } from '../models';
/**
 *
 */
var UserGroupsApi = /** @class */ (function (_super) {
    __extends(UserGroupsApi, _super);
    function UserGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add permissions to user group
     */
    UserGroupsApi.prototype.addPermissionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling addPermissions.');
                        }
                        if (requestParameters.addPermissionsUserGroupRequest === null ||
                            requestParameters.addPermissionsUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('addPermissionsUserGroupRequest', 'Required parameter requestParameters.addPermissionsUserGroupRequest was null or undefined when calling addPermissions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}/permissions".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: AddPermissionsUserGroupRequestToJSON(requestParameters.addPermissionsUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add permissions to user group
     */
    UserGroupsApi.prototype.addPermissions = function (userGroupId, addPermissionsUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addPermissionsRaw({
                            userGroupId: userGroupId,
                            addPermissionsUserGroupRequest: addPermissionsUserGroupRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Add users to user group
     */
    UserGroupsApi.prototype.addUsersRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling addUsers.');
                        }
                        if (requestParameters.addUsersUserGroupRequest === null ||
                            requestParameters.addUsersUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('addUsersUserGroupRequest', 'Required parameter requestParameters.addUsersUserGroupRequest was null or undefined when calling addUsers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}/users".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: AddUsersUserGroupRequestToJSON(requestParameters.addUsersUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add users to user group
     */
    UserGroupsApi.prototype.addUsers = function (userGroupId, addUsersUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addUsersRaw({ userGroupId: userGroupId, addUsersUserGroupRequest: addUsersUserGroupRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create user group
     */
    UserGroupsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createUserGroupRequest === null ||
                            requestParameters.createUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('createUserGroupRequest', 'Required parameter requestParameters.createUserGroupRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateUserGroupRequestToJSON(requestParameters.createUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserGroupRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create user group
     */
    UserGroupsApi.prototype.create = function (createUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createUserGroupRequest: createUserGroupRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch user group by id
     */
    UserGroupsApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserGroupRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch user group by id
     */
    UserGroupsApi.prototype.get = function (userGroupId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ userGroupId: userGroupId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all user assigned permissions for a user group
     */
    UserGroupsApi.prototype.getPermissionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling getPermissions.');
                        }
                        queryParameters = {};
                        if (requestParameters.filter !== undefined) {
                            queryParameters['filter'] = requestParameters.filter;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}/permissions".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(PermissionRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all user assigned permissions for a user group
     */
    UserGroupsApi.prototype.getPermissions = function (userGroupId, filter) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPermissionsRaw({ userGroupId: userGroupId, filter: filter })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all user groups
     */
    UserGroupsApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/userGroups",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(UserGroupRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all user groups
     */
    UserGroupsApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete user group
     */
    UserGroupsApi.prototype.removeRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling remove.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete user group
     */
    UserGroupsApi.prototype.remove = function (userGroupId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeRaw({ userGroupId: userGroupId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove permissions from user group
     */
    UserGroupsApi.prototype.removePermissionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling removePermissions.');
                        }
                        if (requestParameters.removePermissionsUserGroupRequest === null ||
                            requestParameters.removePermissionsUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('removePermissionsUserGroupRequest', 'Required parameter requestParameters.removePermissionsUserGroupRequest was null or undefined when calling removePermissions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}/permissions".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: RemovePermissionsUserGroupRequestToJSON(requestParameters.removePermissionsUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove permissions from user group
     */
    UserGroupsApi.prototype.removePermissions = function (userGroupId, removePermissionsUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removePermissionsRaw({
                            userGroupId: userGroupId,
                            removePermissionsUserGroupRequest: removePermissionsUserGroupRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove users from user group
     */
    UserGroupsApi.prototype.removeUsersRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling removeUsers.');
                        }
                        if (requestParameters.removeUsersUserGroupRequest === null ||
                            requestParameters.removeUsersUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('removeUsersUserGroupRequest', 'Required parameter requestParameters.removeUsersUserGroupRequest was null or undefined when calling removeUsers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}/users".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: RemoveUsersUserGroupRequestToJSON(requestParameters.removeUsersUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove users from user group
     */
    UserGroupsApi.prototype.removeUsers = function (userGroupId, removeUsersUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeUsersRaw({
                            userGroupId: userGroupId,
                            removeUsersUserGroupRequest: removeUsersUserGroupRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Search userGroups with entity permissions for target
     */
    UserGroupsApi.prototype.searchUserGroupEntityPermissionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.searchEntityPermissionsRequest === null ||
                            requestParameters.searchEntityPermissionsRequest === undefined) {
                            throw new runtime.RequiredError('searchEntityPermissionsRequest', 'Required parameter requestParameters.searchEntityPermissionsRequest was null or undefined when calling searchUserGroupEntityPermissions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/entityPermissions/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: SearchEntityPermissionsRequestToJSON(requestParameters.searchEntityPermissionsRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(EntityPermissionsRepresentationFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Search userGroups with entity permissions for target
     */
    UserGroupsApi.prototype.searchUserGroupEntityPermissions = function (searchEntityPermissionsRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchUserGroupEntityPermissionsRaw({
                            searchEntityPermissionsRequest: searchEntityPermissionsRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update user group
     */
    UserGroupsApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
                            throw new runtime.RequiredError('userGroupId', 'Required parameter requestParameters.userGroupId was null or undefined when calling update.');
                        }
                        if (requestParameters.updateUserGroupRequest === null ||
                            requestParameters.updateUserGroupRequest === undefined) {
                            throw new runtime.RequiredError('updateUserGroupRequest', 'Required parameter requestParameters.updateUserGroupRequest was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/userGroups/{userGroupId}".replace("{".concat('userGroupId', "}"), encodeURIComponent(String(requestParameters.userGroupId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateUserGroupRequestToJSON(requestParameters.updateUserGroupRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update user group
     */
    UserGroupsApi.prototype.update = function (userGroupId, updateUserGroupRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({ userGroupId: userGroupId, updateUserGroupRequest: updateUserGroupRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UserGroupsApi;
}(runtime.BaseAPI));
export { UserGroupsApi };
